export default class NavigateHome {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.router.navigateHome();
  }
}
